import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('check_out_our_brand_new_accruals_report'),
    netGross: defineMessage('netgross_amount_selection'),
    netGrossDescription: defineMessage('easily_switch_between_n_arer_financial_overview'),
    poBalance: defineMessage('po_remaining_balance'),
    poBalanceDescription: defineMessage('stay_on_top_of_your_pur_maining_balance_feature'),
    autoPushing: defineMessage('autopushing_to_xero'),
    autoPushingDescription: defineMessage('streamline_your_workflo_your_accruals_with_xero'),
    approvalsAdded: defineMessage('approvals_added'),
    approvalsAddedDescription: defineMessage('improve_your_accruals_a_ore_efficient_approvals'),
    learnMore: defineMessage('learn_more_1'),
    tryForFree: defineMessage('try_it_for_free_1'),
};
